<template>
  <div id="devices">
    <v-card>
      <!-- Mobile Filter Toggle -->
      <v-expansion-panels v-model="filtersExpanded" flat class="d-sm-none mobile-filters">
        <v-expansion-panel>
          <v-expansion-panel-header class="py-2">
            <span class="font-weight-medium">
              <v-icon left small>{{ icons.mdiFilterVariant }}</v-icon>
              Filters
              <v-chip v-if="activeFilterCount > 0" x-small color="primary" class="ml-2">{{ activeFilterCount }}</v-chip>
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row class="pt-2 pb-0 ma-0">
              <v-col cols="6">
                <v-text-field
                  v-model="sqDeviceID"
                  label="Device ID"
                  outlined
                  hide-details
                  dense
                  class="user-search"
                  @change="val => addToSearchHistory(val, 'sqDeviceID')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="sqHardwareID"
                  label="Hardware ID"
                  outlined
                  hide-details
                  dense
                  class="user-search"
                  @change="val => addToSearchHistory(val, 'sqHardwareID')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="sqTags"
                  label="Tags"
                  outlined
                  hide-details
                  dense
                  class="user-search"
                  @change="val => addToSearchHistory(val, 'sqTags')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="sqVehicleID"
                  label="Vehicle ID"
                  outlined
                  hide-details
                  dense
                  class="user-search"
                  @change="val => addToSearchHistory(val, 'sqVehicleID')"
                >
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="sqDStatus"
                  :items="dStatusItems"
                  item-text="text"
                  item-value="value"
                  label="Status"
                  outlined
                  hide-details
                  clearable
                  dense
                  class="user-search"
                  @change="val => addToSearchHistory(val, 'sqDStatus')"
                >
                </v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="sqVersion"
                  :items="dReleaseVersionItems"
                  item-text="text"
                  item-value="value"
                  label="Release Version"
                  outlined
                  hide-details
                  clearable
                  dense
                  class="user-search"
                  @change="val => addToSearchHistory(val, 'sqVersion')"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="sqOsVersion"
                  :items="osVersions"
                  item-text="text"
                  item-value="value"
                  label="OS Version"
                  outlined
                  hide-details
                  clearable
                  dense
                  class="user-search"
                  @change="val => addToSearchHistory(val, 'sqOsVersion')"
                ></v-select>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- Desktop Filters (hidden on mobile) -->
      <v-row class="pt-4 pb-0 ma-0 d-none d-sm-flex align-center">
        <v-col class="pa-0">
          <v-row class="ma-0 d-none d-sm-flex">
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="sqDeviceID"
                label="Device ID"
                outlined
                hide-details
                dense
                @change="val => addToSearchHistory(val, 'sqDeviceID')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="sqHardwareID"
                label="Hardware ID"
                outlined
                hide-details
                dense
                @change="val => addToSearchHistory(val, 'sqHardwareID')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="sqTags"
                label="Tags"
                outlined
                hide-details
                dense
                @change="val => addToSearchHistory(val, 'sqTags')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-text-field
                v-model="sqVehicleID"
                label="Vehicle ID"
                outlined
                hide-details
                dense
                @change="val => addToSearchHistory(val, 'sqVehicleID')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="sqLocation"
                label="Location"
                outlined
                hide-details
                dense
                @change="val => addToSearchHistory(val, 'sqLocation')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="2">
              <v-select
                v-model="sqDStatus"
                :items="dStatusItems"
                item-text="text"
                item-value="value"
                label="Status"
                outlined
                hide-details
                clearable
                dense
                @change="val => addToSearchHistory(val, 'sqDStatus')"
              >
              </v-select>
            </v-col>
            <v-col cols="12" sm="2">
              <v-select
                v-model="sqVersion"
                :items="dReleaseVersionItems"
                item-text="text"
                item-value="value"
                label="Release Version"
                outlined
                hide-details
                clearable
                dense
                @change="val => addToSearchHistory(val, 'sqVersion')"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="2">
              <v-select
                v-model="sqOsVersion"
                :items="osVersions"
                item-text="text"
                item-value="value"
                label="OS Version"
                outlined
                hide-details
                clearable
                dense
                @change="val => addToSearchHistory(val, 'sqOsVersion')"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="sqSsdSerial"
                label="SSD ID"
                outlined
                hide-details
                dense
                @change="val => addToSearchHistory(val, 'sqSsdSerial')"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
              <v-text-field
                v-model="sqSimID"
                label="SIM ID"
                outlined
                hide-details
                dense
                @change="val => addToSearchHistory(val, 'sqSimID')"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="auto" class="d-flex flex-column justify-center">
          <v-btn
            class="mb-2 text-capitalize"
            color="primary"
            outlined
            :disabled="!selectedHardwareIds.length"
            @click="$router.push(updateLocationRoute)"
          >
            <v-icon left size="20">{{ icons.mdiSwapHorizontal }}</v-icon> Transfer
          </v-btn>
          <v-btn
            class="mb-2 text-capitalize"
            color="primary"
            outlined
            :disabled="!selectedDeviceIds.length"
            @click="$router.push(viewMetricsRoute)"
          >
            <v-icon left size="20">{{ icons.mdiChartLine }}</v-icon>
            View Metrics
          </v-btn>
          <v-menu offset-y :close-on-content-click="false" left attach>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="primary" v-bind="attrs" class="text-capitalize bg-white" v-on="on">
                <v-icon left size="20">{{ icons.mdiViewColumn }}</v-icon>
                Columns
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense max-height="400" class="overflow-y-auto">
              <v-list-item v-for="h in columnSelectableHeaders" :key="h.value" @click.stop="toggleColumn(h.value)">
                <v-list-item-action class="mr-2">
                  <v-simple-checkbox
                    :ripple="false"
                    :value="activeHeaders.includes(h.value)"
                    color="primary"
                    @click.stop="toggleColumn(h.value)"
                  ></v-simple-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ h.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <!-- Devices Filter fields end -->

      <!-- Devices Table start -->
      <v-data-table
        v-model="selectedDevices"
        :headers="deviceHeaders"
        :items="filteredDevices"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :custom-sort="customSort"
        class="text--primary"
        :page.sync="page"
        item-key="device_id"
        show-select
        :must-sort="true"
      >
        <template v-slot:item.device_id="{ item }">
          <router-link
            :to="{ name: 'next-stop-device-config', params: { id: item.device_id } }"
            class="cursor-pointer text-decoration-none"
          >
            <span class="font-weight-semibold text--primary">{{ item.device_id }}</span>
          </router-link>
        </template>

        <template v-slot:item.formattedVehicleId="{ item }">
          <router-link
            v-if="item.config.vehicle_id"
            :to="{ name: 'next-stop-vehicle-config', params: { id: item.config.vehicle_id } }"
            class="cursor-pointer text-decoration-none"
          >
            <v-chip small link>{{ item.config.vehicle_id }}</v-chip>
          </router-link>
          <span v-else>-</span>
        </template>

        <template v-slot:item.convertPositionDate="{ item }">
          <span class="text-no-wrap">{{ convertPositionDate(item) }}</span>
        </template>

        <template v-slot:item.release_version="{ item }">
          <span :class="isLatestRelease(item) ? 'success--text' : 'error--text'">{{
            item.status.release_version
          }}</span>
        </template>

        <template v-slot:item.location.receiving_organisation="{ item }">
          <template v-if="item.location && item.location.receiving_organisation">{{
            item.location.receiving_organisation
          }}</template>
          <template v-else>-</template>
        </template>

        <template v-slot:item.location.status="{ item }">
          <template v-if="item.location && item.location.status">
            <span class="text-pre-wrap">{{ item.location.status }}</span>
          </template>
          <template v-else>-</template>
        </template>

        <template v-slot:item.os_version="{ item }">
          {{ item.status.os_version }} {{ item.status.os_variant }}
        </template>

        <template v-slot:item.config.ssd_serial="{ item }">
          {{ item.config.ssd_serial }}
        </template>

        <template v-slot:item.config.case_id="{ item }">
          {{ item.config.case_id }}
        </template>

        <template v-slot:item.ssd.model="{ item }">
          <template v-if="item.ssd && item.ssd.model">{{ item.ssd.model }}</template>
          <template v-else>-</template>
        </template>

        <template v-slot:item.ssd.remaining_life_pct="{ item }">
          <template v-if="hasSsdValue(item, 'remaining_life_pct')">{{ item.ssd.remaining_life_pct }}</template>
          <template v-else>-</template>
        </template>

        <template v-slot:item.ssd.power_on_hours="{ item }">
          <template v-if="hasSsdValue(item, 'power_on_hours')">{{ item.ssd.power_on_hours }}</template>
          <template v-else>-</template>
        </template>

        <template v-slot:item.ssd.power_cycles="{ item }">
          <template v-if="hasSsdValue(item, 'power_cycles')">{{ item.ssd.power_cycles }}</template>
          <template v-else>-</template>
        </template>

        <template v-slot:item.ssd.host_writes_tib="{ item }">
          <template v-if="hasSsdValue(item, 'host_writes_tib')">{{ item.ssd.host_writes_tib }}</template>
          <template v-else>-</template>
        </template>

        <template v-slot:item.ssd.sample_datetime="{ item }">
          <span class="text-no-wrap">{{ convertSsdSampleDate(item) }}</span>
        </template>

        <template v-slot:item.tags="{ item }">
          <TagChips :config="item.config" />
        </template>

        <template v-slot:item.device_status="{ item }">
          <div class="d-flex align-start my-1">
            <div class="d-flex flex-column">
              <v-chip :color="getStatusColour(item.status.status)" label>{{ item.status.status }}</v-chip>
              <span v-if="getLimitedReason(item)" class="text-xs text--secondary mt-0 text-center">
                {{ getLimitedReason(item) }}
              </span>
            </div>

            <v-menu v-if="getServicesNotRunning(item).length" offset-y left max-width="220">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small color="warning" class="ms-1" v-bind="attrs" v-on="on">
                  <v-icon size="20">{{ icons.mdiAlertCircleOutline }}</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-text class="py-2 px-3">
                  <div class="text-sm font-weight-semibold text--primary mb-1">Services not running</div>
                  <div v-for="service in getServicesNotRunning(item)" :key="service" class="text-xs text--secondary">
                    {{ service }}
                  </div>
                </v-card-text>
              </v-card>
            </v-menu>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn icon :to="{ name: 'next-stop-device-config', params: { id: item.device_id } }">
            <v-icon color="primary">
              {{ icons.mdiSquareEditOutline }}
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
      <CSVExportButton
        class="d-none d-sm-block"
        :sort-by="sortBy"
        :items="devices"
        :column-map="deviceColumnMap"
        :sort-desc="sortDesc"
      >
      </CSVExportButton>
      <!-- Devices Table end -->

      <v-btn
        class="ma-3 d-sm-none"
        color="primary"
        outlined
        :disabled="!selectedHardwareIds.length"
        @click="$router.push(updateLocationRoute)"
      >
        <v-icon left size="20">{{ icons.mdiSwapHorizontal }}</v-icon> Transfer
      </v-btn>
      <v-btn
        class="ma-3 d-sm-none"
        color="primary"
        outlined
        :disabled="!selectedDeviceIds.length"
        @click="$router.push(viewMetricsRoute)"
      >
        <v-icon left size="20">{{ icons.mdiChartLine }}</v-icon>
        View Metrics
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import {
  mdiAlertCircleOutline,
  mdiSquareEditOutline,
  mdiFilterVariant,
  mdiChartLine,
  mdiSwapHorizontal,
  mdiViewColumn,
} from "@mdi/js"
import { mapState } from "vuex"
import useAppConfig from "@core/@app-config/useAppConfig"
import store from "@/store"
import CSVExportButton from "@/views/next-stop/components/CSVExportButton.vue"
import TagChips from "@/views/next-stop/components/TagChips.vue"
import urlHelpers from "@/mixins/urlHelpers"
import globalHelpers from "@/mixins/globalHelpers"
import { getConfigTags, getConfigTagsText } from "@/utils/tags"

export default {
  name: "DeviceList",
  metaInfo: {
    title: "Devices",
  },
  components: {
    CSVExportButton,
    TagChips,
  },
  mixins: [urlHelpers, globalHelpers],

  data() {
    return {
      activeHeaders: [
        "device_id",
        "formattedVehicleId",
        "convertPositionDate",
        "release_version",
        "config.case_id",
        "device_status",
        "location.receiving_organisation",
        "location.status",
        "tags",
      ],
      filtersExpanded: undefined,
      devicesLiveUpdate: null,
      sqVehicleID: "",
      sqHardwareID: "",
      sqLocation: "",
      sqDeviceID: "",
      sqMStatus: "",
      sqDStatus: "",
      sqVersion: "",
      sqOsVersion: "",
      sqSsdSerial: "",
      sqSimID: "",
      sqTags: "",
      sortBy: "device_id",
      sortDesc: false,
      // Device Table Headers
      desktopDeviceHeaders: [
        { text: "Device ID", value: "device_id" },
        { text: "Hardware ID", value: "config.case_id" },
        { text: "Tags", value: "tags" },
        { text: "Vehicle ID", value: "formattedVehicleId" },
        { text: "Last Position", value: "convertPositionDate" },
        { text: "Location Organisation", value: "location.receiving_organisation" },
        { text: "Location Status", value: "location.status" },
        { text: "Release Version", value: "release_version" },
        { text: "OS Version", value: "os_version" },
        { text: "SSD ID", value: "config.ssd_serial" },
        { text: "SSD Model", value: "ssd.model" },
        { text: "SSD Remaining Life (%)", value: "ssd.remaining_life_pct" },
        { text: "SSD Power On Hours", value: "ssd.power_on_hours" },
        { text: "SSD Power Cycles", value: "ssd.power_cycles" },
        { text: "SSD Host Writes (TiB)", value: "ssd.host_writes_tib" },
        { text: "SSD Sampled", value: "ssd.sample_datetime" },
        { text: "SIM ID", value: "config.sim_id" },
        { text: "Status", value: "device_status" },
        { text: "", value: "action", sortable: false },
      ],
      mobileDeviceHeaders: [
        { text: "Hardware ID", value: "config.case_id" },
        { text: "Status", value: "device_status" },
        { text: "", value: "action", sortable: false },
      ],
      deviceColumnMap: [
        { text: "Device ID", value: "device_id" },
        { text: "Hardware ID", value: "config.case_id" },
        { text: "Vehicle ID", value: "config.vehicle_id", conversionFunc: "emptyNice" },
        { text: "Last Position", value: "status.position_timestamp", conversionFunc: "formatDateTimeStamp" },
        { text: "Location Organisation", value: "location.receiving_organisation" },
        { text: "Location Status", value: "location.status" },
        { text: "Release Version", value: "status.release_version" },
        { text: "OS Version", value: "status.os_version" },
        { text: "SSD ID", value: "config.ssd_serial" },
        { text: "SSD Model", value: "ssd.model" },
        { text: "SSD Remaining Life (%)", value: "ssd.remaining_life_pct" },
        { text: "SSD Power On Hours", value: "ssd.power_on_hours" },
        { text: "SSD Power Cycles", value: "ssd.power_cycles" },
        { text: "SSD Host Writes (TiB)", value: "ssd.host_writes_tib" },
        { text: "SSD Sampled", value: "ssd.sample_datetime" },
        { text: "SIM ID", value: "config.sim_id" },
        { text: "Tags", value: "config.tag_details", conversionFunc: "tagsNice" },
        { text: "Status", value: "status.status" },
      ],
      dStatusItems: [
        {
          text: "idle",
          value: "idle",
        },
        {
          text: "offline",
          value: "offline",
        },
        {
          text: "limited",
          value: "limited",
        },
        {
          text: "updating",
          value: "updating",
        },
      ],
      dReleaseVersionItems: [
        {
          text: "latest",
          value: "latest",
        },
        {
          text: "outdated",
          value: "outdated",
        },
      ],
      formData: {
        title: "",
        description: "",
        selectedDevice: null,
      },
      dialog: false,
      is_loading: true,
    }
  },
  setup() {
    return {
      icons: {
        mdiAlertCircleOutline,
        mdiSquareEditOutline,
        mdiFilterVariant,
        mdiViewColumn,
        mdiChartLine,
        mdiSwapHorizontal,
      },
    }
  },

  computed: {
    ...mapState({
      devices: state => state.gtfs.devices,
      persistedHardwareIds: state => state.selected_device_hardware_ids,
    }),
    selectedDevices: {
      get() {
        const ids = this.persistedHardwareIds
        if (!ids.length) return []

        return this.devices.filter(device => ids.includes(device?.config?.case_id))
      },
      set(newSelection) {
        const ids = [...new Set(newSelection.map(device => device?.config?.case_id).filter(item => !!item))]
        this.$store.commit("SET_SELECTED_DEVICE_HARDWARE_IDS", ids)
      },
    },
    activeFilterCount() {
      let count = 0
      if (this.sqDeviceID) count += 1
      if (this.sqVehicleID) count += 1
      if (this.sqDStatus) count += 1
      if (this.sqVersion) count += 1
      if (this.sqOsVersion) count += 1
      if (this.sqTags) count += 1

      return count
    },
    deviceHeaders() {
      if (this.$vuetify.breakpoint.xs) {
        return this.mobileDeviceHeaders
      }

      return this.desktopDeviceHeaders.filter(
        header => header.value === "action" || this.activeHeaders.includes(header.value),
      )
    },
    columnSelectableHeaders() {
      return this.desktopDeviceHeaders.filter(header => header.value !== "action")
    },
    // Devices Filtering
    filteredDevices() {
      return this.devices.filter(device => {
        let include = true

        if (include && this.sqVehicleID.length) {
          if (this.sqVehicleID === "-") {
            include = device.config.vehicle_id === null || device.config.vehicle_id === ""
          } else {
            include = device.config.vehicle_id?.toLowerCase().includes(this.sqVehicleID.toLowerCase())
          }
        }

        if (include && this.sqDeviceID.length) {
          include = device.device_id?.toLowerCase().includes(this.sqDeviceID.toLowerCase())
        }

        if (include && this.sqHardwareID.length) {
          include = device.config.case_id?.toLowerCase().includes(this.sqHardwareID.toLowerCase())
        }

        if (include && this.sqSsdSerial.length) {
          include = device.config.ssd_serial?.toLowerCase().includes(this.sqSsdSerial.toLowerCase())
        }

        if (include && this.sqSimID.length) {
          include = device.config.sim_id?.toLowerCase().includes(this.sqSimID.toLowerCase())
        }

        if (include && this.sqLocation.length) {
          include =
            device.location?.status?.toLowerCase().includes(this.sqLocation.toLowerCase()) ||
            device.location?.receiving_organisation?.toLowerCase().includes(this.sqLocation.toLowerCase())
        }

        if (include && this.sqDStatus !== "" && this.sqDStatus !== null) {
          include = device.status.status === this.sqDStatus
        }

        if (include && this.sqVersion !== "" && this.sqVersion !== null) {
          include = this.isLatestRelease(device) ? this.sqVersion === "latest" : this.sqVersion === "outdated"
        }

        if (include && this.sqOsVersion !== "" && this.sqOsVersion !== null) {
          const version = `${device.status.os_version || ""} ${device.status.os_variant || ""}`
          include = version.trim() !== "" ? this.sqOsVersion === version : false
        }

        if (include && this.sqTags.length) {
          const searchTags = this.sqTags
            .toLowerCase()
            .split(",")
            .map(tag => tag.trim())
            .filter(tag => tag.length > 0)
          const deviceTags = getConfigTags(device.config).map(tag => tag.toLowerCase())
          include = searchTags.some(tag => deviceTags.some(deviceTag => deviceTag.includes(tag)))
        }

        return include
      })
    },

    formattedVehicleId() {
      // eslint-disable-next-line func-names
      return function (item) {
        return item.config.vehicle_id ? item.config.vehicle_id : "Unknown"
      }
    },
    selectedHardwareIds() {
      return [...new Set(this.selectedDevices.map(device => device?.config?.case_id).filter(item => !!item))]
    },
    updateLocationRoute() {
      return {
        name: "next-stop-devices",
        query: {
          ...this.$route.query,
          tab: "transfers",
        },
      }
    },
    selectedDeviceIds() {
      return [...new Set(this.selectedDevices.map(device => device?.device_id).filter(item => !!item))]
    },
    viewMetricsRoute() {
      return {
        name: "next-stop-devices",
        query: {
          tab: "metrics",
          deviceIds: this.selectedDeviceIds.join(","),
        },
      }
    },

    fetchVehicleId() {
      // eslint-disable-next-line func-names
      return function (item) {
        return this.getVehicleId(item.device_id)
      }
    },

    convertPositionDate() {
      // eslint-disable-next-line func-names
      return function (item) {
        return item.status.position_timestamp ? this.formatDate(item.status.position_timestamp) : "Unknown"
      }
    },

    convertCreatedDate() {
      // eslint-disable-next-line func-names
      return function (item) {
        return item.created ? this.formatDate(item.created) : "Unknown"
      }
    },

    osVersions() {
      const versions = this.devices
        .map(item => {
          if (item.status.os_version && item.status.os_variant) {
            return `${item.status.os_version} ${item.status.os_variant}`
          }

          return ""
        })
        .filter(item => item)

      return [...new Set([...versions])].map(item => ({ text: item, value: item }))
    },
  },

  mounted() {
    const { refreshIntervalDevices } = useAppConfig()

    this.devicesLiveUpdate = setInterval(async () => {
      await store.dispatch("getDevices")
    }, refreshIntervalDevices * 1000)
  },

  beforeDestroy() {
    clearInterval(this.devicesLiveUpdate)
    clearInterval(this.liveUpdate)
  },

  methods: {
    openDialog() {
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
    },
    // Zero is a real reading for these, so a plain truthiness check in the
    // template would show it as missing
    hasSsdValue(item, field) {
      return item.ssd?.[field] !== null && item.ssd?.[field] !== undefined && item.ssd?.[field] !== ""
    },
    // The API sends local time with no zone, e.g. 2026-09-21T14:54:44, so this
    // reformats the text rather than parsing it, which would risk a zone shift
    convertSsdSampleDate(item) {
      const value = item.ssd?.sample_datetime
      if (!value) {
        return "-"
      }

      const match = /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/.exec(value)

      return match ? `${match[1]} ${match[2]}` : value
    },
    toggleColumn(columnValue) {
      const index = this.activeHeaders.indexOf(columnValue)
      if (index > -1) {
        this.activeHeaders.splice(index, 1)
      } else {
        this.activeHeaders.push(columnValue)
      }
    },
    refreshList() {
      store.dispatch("getDevices")
    },
    getVehicleId(deviceId) {
      const device = this.devices.find(d => d.device_id === deviceId)

      return device && device.config.vehicle_id ? device.config.vehicle_id : "Unknown"
    },
    customSort(items, sortBy, sortDesc) {
      const sortByField = sortBy[0] ?? ""
      const sortDescending = sortDesc[0] ?? false

      // Devices that have never reported an SSD have no reading to rank, so
      // they are held out of the sort and appended afterwards, which keeps them
      // at the bottom whichever direction the column is sorted. Leaving them in
      // would also make them compare as equal to every reading, which is
      // inconsistent enough to scramble the rows that do have one.
      const ssdField = sortByField.startsWith("ssd.") ? sortByField.slice("ssd.".length) : ""
      const blanks = ssdField ? items.filter(item => !this.hasSsdValue(item, ssdField)) : []
      const ranked = ssdField ? items.filter(item => this.hasSsdValue(item, ssdField)) : items

      ranked.sort((a, b) => {
        let sortA = a[sortByField]
        let sortB = b[sortByField]

        // Special handling of field sorting when required
        switch (sortByField) {
          case "formattedVehicleId": {
            sortA = this.formattedVehicleId(a)
            sortB = this.formattedVehicleId(b)

            break
          }
          case "convertPositionDate": {
            sortA = this.convertPositionDate(a)
            sortB = this.convertPositionDate(b)

            break
          }
          case "device_id": {
            sortA = (a.device_id ?? "").toString().toLowerCase()
            sortB = (b.device_id ?? "").toString().toLowerCase()

            break
          }
          case "config.case_id": {
            sortA = (a.config?.case_id ?? "").toString().toLowerCase()
            sortB = (b.config?.case_id ?? "").toString().toLowerCase()

            break
          }
          case "tags": {
            sortA = getConfigTagsText(a.config).toLowerCase()
            sortB = getConfigTagsText(b.config).toLowerCase()

            break
          }
          case "location.receiving_organisation": {
            sortA = (a.location?.receiving_organisation ?? "").toString().toLowerCase()
            sortB = (b.location?.receiving_organisation ?? "").toString().toLowerCase()

            break
          }
          case "location.status": {
            sortA = (a.location?.status ?? "").toString().toLowerCase()
            sortB = (b.location?.status ?? "").toString().toLowerCase()

            break
          }
          case "config.ssd_serial": {
            sortA = a.config.ssd_serial
            sortB = b.config.ssd_serial

            break
          }
          case "case_id": {
            sortA = a.config.case_id
            sortB = b.config.case_id

            break
          }
          case "config.sim_id": {
            sortA = a.config.sim_id
            sortB = b.config.sim_id

            break
          }
          case "device_status": {
            sortA = a.status.status
            sortB = b.status.status

            break
          }
          case "release_version": {
            sortA = a.status.release_version
            sortB = b.status.release_version

            break
          }
          case "os_version": {
            sortA = a.status.os_version
            sortB = b.status.os_version

            break
          }

          case "ssd.model": {
            sortA = (a.ssd?.model ?? "").toString().toLowerCase()
            sortB = (b.ssd?.model ?? "").toString().toLowerCase()

            break
          }
          case "ssd.remaining_life_pct": {
            sortA = a.ssd?.remaining_life_pct
            sortB = b.ssd?.remaining_life_pct

            break
          }
          case "ssd.power_on_hours": {
            sortA = a.ssd?.power_on_hours
            sortB = b.ssd?.power_on_hours

            break
          }
          case "ssd.power_cycles": {
            sortA = a.ssd?.power_cycles
            sortB = b.ssd?.power_cycles

            break
          }
          case "ssd.host_writes_tib": {
            sortA = a.ssd?.host_writes_tib
            sortB = b.ssd?.host_writes_tib

            break
          }
          case "ssd.sample_datetime": {
            sortA = a.ssd?.sample_datetime ?? ""
            sortB = b.ssd?.sample_datetime ?? ""

            break
          }

          default: {
            break
          }
        }

        if (sortA > sortB) return 1
        if (sortA < sortB) return -1

        return 0
      })

      // Reverse order if header clicked again
      if (sortDescending) {
        ranked.reverse()
      }

      return [...ranked, ...blanks]
    },

    isLatestRelease(item) {
      return item.status.release_version === item.status.target_release_version
    },
    // Limited is the one status where being unreachable is the whole story, so
    // that is where the reason is worth the extra line
    getLimitedReason(item) {
      return item.status?.status === "limited" ? item.status?.is_reachable?.reason || "" : ""
    },
    getServicesNotRunning(item) {
      return item.status?.services_not_running || []
    },
    getStatusColour(status) {
      switch (status) {
        case "idle":
          return "success"
        case "limited":
        case "updating":
          return "warning"
        case "offline":
          return "error"

        default:
          return "success"
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-filters {
  .v-expansion-panel-header {
    min-height: 48px;
  }

  .v-expansion-panel-content__wrap {
    padding: 0 16px 16px;
  }
}
</style>
